import { AGENCY_SHARE_CHAT } from '@rsos/capstone/src/constants/capabilities';

/**
 * Function to determine if the current user's authority has the
 * `agency_share_chat` capability turned on
 * @param {Object} psaps - PSAPS reducer
 */
const isAgencyShareChatEnabled = psaps => {
  return !!psaps.currentPSAP?.activeCapabilities?.[AGENCY_SHARE_CHAT];
};

export default isAgencyShareChatEnabled;
